module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/703b25887f5775c8449ceb8949f0bf44.png";